import React from 'react';
import * as cls from './footer.module.css';
import { Section } from '../../components/section';
import { Link } from 'react-router-dom';
import { IMG_PATH, ROUTES_PATHS } from '../../../constants';

export const Footer = () => {
  return (
    <footer className={cls.footer}>
      <Section classNameRoot={cls['footer__section']}>
        <nav className={cls.nav}>
          <ul>
            <li>
              <Link className={cls.link} to={ROUTES_PATHS.ABOUT}>
                About us
              </Link>
            </li>
            <li>
              <Link className={cls.link} to={ROUTES_PATHS.CONTACT}>
                Contact us
              </Link>
            </li>
            <li>
              <Link className={cls.link} to={ROUTES_PATHS.CAREERS}>
                Careers
              </Link>
            </li>
            <li>
              <Link className={cls.link} to={ROUTES_PATHS.BLOG}>
                Blog
              </Link>
            </li>
          </ul>

          <ul>
            <li>
              <a
                className={cls.link}
                href={ROUTES_PATHS.FOR_BUSINESS}
                rel="noopener noreferrer"
                target="_blank"
              >
                For business
              </a>
            </li>
            <li>
              <Link className={cls.link} to={ROUTES_PATHS.REQUEST_A_DEMO}>
                Request a demo
              </Link>
            </li>
            <li>
              <Link className={cls.link} to={ROUTES_PATHS.FAQ}>
                FAQ
              </Link>
            </li>
          </ul>

          <ul>
            <li>
              <Link className={cls.link} to={ROUTES_PATHS.ACCEPTABLE_USE}>
                Acceptable use
              </Link>
            </li>
            <li>
              <Link className={cls.link} to={ROUTES_PATHS.PRIVACY_POLICY}>
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link className={cls.link} to={ROUTES_PATHS.TERMS_AND_CONDITIONS}>
                Terms & Conditions
              </Link>
            </li>
          </ul>

          <ul className={cls.social}>
            <li>
              <a
                href={ROUTES_PATHS.WHATSAPP}
                rel="noopener noreferrer"
                target="_blank"
              >
                <img src={`${IMG_PATH}/ico-whatsapp.svg`} alt="WhatsApp" />
              </a>
            </li>
            <li>
              <a
                href={ROUTES_PATHS.X}
                rel="noopener noreferrer"
                target="_blank"
              >
                <img src={`${IMG_PATH}/ico-x.svg`} alt="X (Twitter)" />
              </a>
            </li>
            <li>
              <a
                href={ROUTES_PATHS.LINKEDIN}
                rel="noopener noreferrer"
                target="_blank"
              >
                <img src={`${IMG_PATH}/ico-linkedin.svg`} alt="LinkedIn" />
              </a>
            </li>
            <li>
              <a
                href={ROUTES_PATHS.FACEBOOK}
                rel="noopener noreferrer"
                target="_blank"
              >
                <img src={`${IMG_PATH}/ico-facebook.svg`} alt="Facebook" />
              </a>
            </li>
          </ul>
        </nav>

        <div className={cls.mail}>
          <img src={`${IMG_PATH}/ico-mail.svg`} alt="E-mail" />
          <a href={`mailto:${ROUTES_PATHS.EMAIL}`}>{ROUTES_PATHS.EMAIL}</a>
        </div>

        <img
          className={cls.logo}
          src={`${IMG_PATH}/footer-voltaware.svg`}
          alt="Voltaware"
        />
        <img
          className={cls.logo}
          src={`${IMG_PATH}/footer-amazon.svg`}
          alt="Voltaware in Amazon"
        />

        <small>© Voltaware {new Date().getFullYear()}</small>
      </Section>
    </footer>
  );
};
